import { useState, useEffect } from 'react';
import '../App.css';

function InstallPWA() {
  const [supportsPWA, setSupportsPWA] = useState(false);
  const [promptInstall, setPromptInstall] = useState(null);
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      // Store the event for later use
      setPromptInstall(e);
      setSupportsPWA(true);
      
      // Check if user has previously dismissed the prompt
      const pwaPromptDismissed = localStorage.getItem('pwaPromptDismissed');
      if (pwaPromptDismissed) {
        // Only show again if it's been more than 7 days since dismissal
        const dismissedTime = parseInt(pwaPromptDismissed, 10);
        const now = Date.now();
        const daysSinceDismissed = (now - dismissedTime) / (1000 * 60 * 60 * 24);
        
        if (daysSinceDismissed < 7) {
          return;
        }
      }
      
      setShowPrompt(true);
    };

    // Check if the app is already installed
    const isAppInstalled = window.matchMedia('(display-mode: standalone)').matches;
    
    // Only show the prompt if not already installed
    if (!isAppInstalled) {
      window.addEventListener('beforeinstallprompt', handler);
    }

    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const onInstallClick = () => {
    if (!promptInstall) {
      return;
    }
    // Show the install prompt
    promptInstall.prompt();
    
    // Wait for the user to respond to the prompt
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('User accepted the install prompt');
      } else {
        console.log('User dismissed the install prompt');
      }
      setShowPrompt(false);
    });
  };

  const onDismissClick = () => {
    setShowPrompt(false);
    // Store in localStorage that user dismissed the prompt
    localStorage.setItem('pwaPromptDismissed', Date.now().toString());
  };

  // Don't show anything if PWA is not supported or prompt shouldn't be shown
  if (!supportsPWA || !showPrompt) {
    return null;
  }

  return (
    <div className="pwa-install-prompt">
      <div>
        <strong>Install Invoice App</strong>
        <p>Install this app on your device for offline use and a better experience.</p>
      </div>
      <div className="pwa-install-prompt-buttons">
        <button 
          className="pwa-install-prompt-decline" 
          onClick={onDismissClick}
        >
          Not now
        </button>
        <button 
          className="pwa-install-prompt-accept" 
          onClick={onInstallClick}
        >
          Install
        </button>
      </div>
    </div>
  );
}

export default InstallPWA;
